import dynamic from "next/dynamic";
const Layout = dynamic(() => import("../hoc/staticLayout"), {
  loading: () => <></>,
  ssr: true,
});
import { withRouter } from "next/router";
import Leadership from "../components/static/aboutPage/LeadershipPage";
import { getLeadersData } from "../api/leadership";

function Leaders(props) {
  const meta = {
    title: "Bayan LeaderShip | Bayan",
    description: "BAYAN AFFILIATED FACULTY HAIL FROM PREMIER INSTITUTIONS",
    route: "leaders",
  };

  return (
    <Layout theme={props.theme} meta={meta}>
      <Leadership leaders={props.leaders} />
    </Layout>
  );
}
export async function getServerSideProps(context) {
  const allLeaders = await getLeadersData();
  // console.log(allLeaders[0]["Leader"]);
  return {
    props: {
      leaders: allLeaders?.[0]?.["Leader"] ?? null,
    },
  };
}

export default withRouter(Leaders);
